export const PTOM_PLAN_DETAIL = 1
export const PTOM_PLAN_ACCOUNT = 2
// 综合效果报表
export const REPORT_COMPLEX = 3
// 综合效果报表-实时
export const REPORT_REALTIME = 4
//  素材分析
export const REPORT_MATERIAL_ANALYSIS = 5
// 素材分析-分日
export const REPORT_MATERIAL_ANALYSIS_DATE = 6
// 内容标签曲线
export const REPORT_LABEL_LIFECYCLE = 7
// 标签组分析
export const REPORT_LABEL_GROUP_ANALYSIS = 8
// 广告位报表
export const REPORT_AD_POSITION = 9
// 追踪计划
export const REPORT_PLAN_TRACK = 10

export const PAGE_TYPE_LIST = [
  { id: PTOM_PLAN_DETAIL, name: '投放明细-计划' },
  { id: PTOM_PLAN_ACCOUNT, name: '投放明细-账号' },
  { id: REPORT_COMPLEX, name: '综合效果报表-效果' },
  { id: REPORT_REALTIME, name: '综合效果报表-实时' },
  { id: REPORT_MATERIAL_ANALYSIS, name: '素材分析' },
  { id: REPORT_MATERIAL_ANALYSIS_DATE, name: '素材分析-分日数据' },
  { id: REPORT_LABEL_LIFECYCLE, name: '内容曲线标签' },
  { id: REPORT_LABEL_GROUP_ANALYSIS, name: '标签组分析' },
  { id: REPORT_AD_POSITION, name: '投放位报表' },
  { id: REPORT_PLAN_TRACK, name: '追踪计划' }
]
